<template>
    <section class="how-works-section pt-3 pt-lg-5">
        <b-container class="wrap" :style="{backgroundImage : `url(${background})`}">
            <b-row>
                <b-col class="text-center text-md-left" :md="col_md" :lg="col_lg" :xl="col_xl">
                    <h3 class="mb-3">{{title}}</h3>
                    <p class="lead text-muted mb-3"><slot>{{ desc }}</slot></p>

                    <el-button
                      @click="firstNewBike()"
                      type="primary"
                      class="text-uppercase font-weight-bold"
                      round>
                      {{textLink}}
                    </el-button>


                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import bgHowWorks from '@/assets/img/entenda-como-funciona-pedale-img.svg';
import {handleSendFirstNewBike} from "@/helpers/handleSendFirstNewBike";

export default {
    name: 'WelcomePanelBanner',
    props: {
        user: {
           type: Object,
           require: true
        },
        title: {
            type: String,
            default: 'Entenda como funciona o Pedale'
        },
        desc: {
            type: String,
            default: 'Veja como é rápido, prático e seguro alugar uma bicicleta de pessoas que estão próximas a você'
        },
        onLink: {
            type: Boolean,
            default: true
        },
        link: {
            type: String,
            default: '/como-funciona-a-pedale'
        },
        textLink: {
            type: String,
            default: 'Saiba Mais  →'
        },
        background: {
            type: String,
            default: bgHowWorks,
        },
        col_md: {
            type: String,
            default: '8',
        },
        col_lg: {
            type: String,
            default: '6',
        },
        col_xl: {
            type: String,
            default: '5',
        },
       userIsReady: { type: Boolean, default: false },
       userHasBankAccount: { type: Boolean, default: false },
       userHasDigitalAccount: { type: Boolean, default: false },
       userHasDocs: { default: true },
       approvedDigitalAccount: { type: Boolean, default: false },
    },
    data() {
      return {
        bgHowWorks
      }
    },
   methods: {
      firstNewBike() {
         handleSendFirstNewBike(this.user, this.userIsReady, this.userHasBankAccount)
      }
    },
 };
</script>
